import { restClient } from '@/Core'

export const DelegateExecutorTask = async (executorUuid: string, dispatcherIri: string): Promise<void> => {
    await restClient.post(`/services/vehicle-need-executors/${executorUuid}/delegate`, {
        json: { dispatcher: dispatcherIri },
    })
}
